import React from "react";
import logo from "./mpl-logo.png"
import { Page, Document, StyleSheet, View, Text,Image } from "@react-pdf/renderer";

const styles = StyleSheet.create({
//   page: {
//     padding: 10,
//     fontSize: 8,
//   },
//   table: {
//     display: "table",
//     width: "auto",
//     borderStyle: "solid",
//     borderWidth: 1,
//   },
//   row: {
//     flexDirection: "row",
//   },
//   header: {
//     backgroundColor: "#196c91",
//     color: "#fff",
//     fontWeight: "bold",
//   },
//   cell: {
//     borderWidth: 1,
//     padding: 3,
//   },
page: {
    // padding: 10,
    paddingTop: 100, // leave space for header
    paddingHorizontal: 10,
    fontSize: 8,
    paddingBottom:10
  },
//   header
headerFixed: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "15%",         // 🔥 15% fixed height
    // borderBottomWidth: 1,
    borderColor: "#000",
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    backgroundColor:"white"
  },

  logo: {
    width: 160,
    height: 100,
    objectFit: "contain",
  },

  headerTextContainer: {
    marginLeft: 10,
  },

  title: {
    fontSize: 14,
    fontWeight: "bold",
  },

  subtitle: {
    fontSize: 10,
  },
// body
  table: {
    display: "table",
    width: "100%",
    // borderWidth: 1,
    borderTopWidth: 1,
  borderLeftWidth: 1,
  borderRightWidth: 0,
  borderBottomWidth: 0, // ❌ remove bottom border
    borderColor: "#000",
  },
  row: {
    flexDirection: "row",
    width:"100%"
  },
  header: {
    backgroundColor: "#196c91",
    color: "#fff",
    fontWeight: "bold",
   
  },
  cell: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    // borderLeftWidth:1,
    borderColor: "#000",
    padding: 4,
    textAlign: "center",
  },
  Headercell: {
    borderRightWidth: 1,
    borderColor: "white",
    padding: 4,
    textAlign: "center",
  },
});
const PdfReport = ({ columns, data,from,to }) => {
    // const columnWidth = `${100 / columns.length}%`;
    console.log(data)

    const columnWidths = {
        serial_no: "3%",        // smaller
        branch_name: "6%",
        invoice_id: "5%",       // reduced
    
        patient_name: "7%",    // bigger ✅
        age: "5%",
        gender: "5%",           // reduced
        bookDateTime: "11%",    // bigger ✅
        test_title: "12%",
        reporting_DateTime: "10%",
        ref_by: "10%",
        panel_name: "10%",
        ref_no: "6%",           // reduced
        department: "10%",
       
      };
      const getPakistanDateTime = () => {
        const now = new Date();
      
        return now.toLocaleString("en-PK", {
          timeZone: "Asia/Karachi",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      };
      const formatDateTime = (dateString) => {
        const date = new Date(dateString);
      
        return date.toLocaleString("en-PK", {
          timeZone: "Asia/Karachi",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      };
    return (
      <Document>
        <Page size="A4" orientation="landscape" style={styles.page}>
          
          {/* <Text style={{ fontSize: 12, marginBottom: 10 }}>
            Test Feeding List
          </Text> */}
          <View style={styles.headerFixed} fixed>
    <Image src={logo} style={styles.logo} />
    <View style={{ marginLeft: 150,top:30}}>
      <Text style={{ fontSize: 20, fontWeight: "bold" }}>
        Test Feeding List
      </Text>
      {/* <Text style={{ fontSize: 10 }}>
        MPL Laboratory
      </Text> */}
    </View>
    <View style={{ marginLeft: 80,top:40}}>
    <Text style={{ fontSize: 10, fontWeight: "bold" }} > Range : {formatDateTime(from) + "," + formatDateTime(to) }</Text>     
    <Text style={{ fontSize: 10, fontWeight: "bold" ,marginTop:5}} > User Name : {localStorage.getItem("name")} , Date / Time : {getPakistanDateTime()}</Text>     
    {/* <Text style={{ fontSize: 10, fontWeight: "bold" }}> {localStorage.getItem("name")}</Text> */}
    {/* <Text style={{ fontSize: 10, fontWeight: "bold" }} > </Text>      */}
    
  {/* <Text style={{ fontSize: 10, fontWeight: "bold" }}> {getPakistanDateTime()}</Text> */}
      {/* <Text style={{ fontSize: 10 }}>
        MPL Laboratory
      </Text> */}
    </View>
  </View>
  
          <View style={styles.table}>
            
            {/* Header */}
            <View style={[styles.row, styles.header]} fixed>
              {columns.map((col, i) => (
                // <Text key={i} style={[styles.cell, { width: columnWidth }]}>
                <Text
    key={i}
    style={[
      styles.Headercell,
      { width: columnWidths[col.field] || "8%", borderRightWidth: i === columns.length - 1 ? 0 : 1 } // remove right border for last header cell
    ]}
  >
                  {col.title}
                </Text>
              ))}
            </View>
  
            {/* Rows */}
            {data.map((row, i) => (
              <View style={styles.row} wrap={false} key={i}>
                {columns.map((col, j) => (
                //   <Text key={j} style={[styles.cell, { width: columnWidth }]}>
                <Text
    key={j}
    style={[
      styles.cell,
      { width: columnWidths[col.field] || "8%", }
    ]}
    
  >
                    {/* {row[col.field] ?? ""} */}
                    {col.field === "serial_no"
          ? i + 1   // 🔥 serial number
          : row[col.field] ?? ""}
                  </Text>
                ))}
              </View>
            ))}
          </View>
        </Page>
      </Document>
    );
  };
// const PdfReport = ({ columns, data }) => (
//   <Document>
//     <Page size="A4" orientation="landscape" style={styles.page}>
      
//       {/* Title */}
//       <Text style={{ fontSize: 12, marginBottom: 10 }}>
//         Test Feeding List
//       </Text>

//       {/* Table */}
//       <View style={styles.table}>
        
//         {/* Header Row */}
//         <View style={[styles.row, styles.header]}>
//           {columns.map((col, index) => (
//             <Text key={index} style={[styles.cell, { width: col.headerStyle?.minWidth || 80 }]}>
//               {col.title}
//             </Text>
//           ))}
//         </View>

//         {/* Data Rows */}
//         {data.map((row, rowIndex) => (
//           <View style={styles.row} key={rowIndex}>
//             {columns.map((col, colIndex) => (
//               <Text
//                 key={colIndex}
//                 style={[styles.cell, { width: col.cellStyle?.minWidth || 80 }]}
//               >
//                 {row[col.field] ? row[col.field].toString() : ""}
//               </Text>
//             ))}
//           </View>
//         ))}
//       </View>
//     </Page>
//   </Document>
// );

export default PdfReport;